import { FieldName } from '@/constants';
import { getStringFromFormDataEntry } from '@/utils/getStringFromFormDataEntry';

export const getAddressData = (target: EventTarget & HTMLFormElement) => {
  const formData = new FormData(target);

  return {
    [FieldName.Id]: getStringFromFormDataEntry(formData.get('id')),
    [FieldName.FirstName]: getStringFromFormDataEntry(
      formData.get('firstName'),
    ),
    [FieldName.LastName]: getStringFromFormDataEntry(formData.get('lastName')),
    [FieldName.Company]: getStringFromFormDataEntry(formData.get('company')),
    [FieldName.AddressLine1]: getStringFromFormDataEntry(formData.get('line1')),
    [FieldName.AddressLine2]: getStringFromFormDataEntry(formData.get('line2')),
    [FieldName.City]: getStringFromFormDataEntry(formData.get('city')),
    [FieldName.County]: getStringFromFormDataEntry(formData.get('countyCode')),
    [FieldName.PostalCode]: getStringFromFormDataEntry(
      formData.get('postalCode'),
    ),
    [FieldName.Country]: getStringFromFormDataEntry(
      formData.get('countryCode'),
    ),
    [FieldName.Phone]: getStringFromFormDataEntry(formData.get('phone')),
  };
};
